import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../../../utils/axios";
import { DeleteIcon, EditIcon } from "../../../icons/StatusIcons";

const DealerCard = (props) => {
  const [endDate, setEndDate] = useState("");
  const [dealerEndDate, setDealerEndDate] = useState("");

  const handleDetail = async (id) => {
    await axios
      .post("view/dealer/detail/device/list", {
        dealerId: id,
      })
      .then((response) => {
        if (response.data.subscriptionEnd !== null) {
          // setEndDate(response.data.subscriptionEnd);
          setEndDate(
            new Date(response.data.subscriptionEnd).toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "short",
                day: "numeric",
              }
            )
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const handleDealerDetail = async (dealerId) => {
    await axios
      .post("view/dealer/detail/device/list", {
        dealerId: dealerId,
      })
      .then((response) => {
        if (response.data.subscriptionEnd !== null) {
          setDealerEndDate(response.data.subscriptionEnd);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    handleDetail(props.id);
    handleDealerDetail(props.dealerId);
  }, []);

  return (
    <div className="detail-listing-wrap">
      <div className="listing-detail-wrap">
        <Link to={props.link}>
          <h4 className="user-name text-dark">{props.name}</h4>
          <p className="user-company text-dark">{props.company}</p>
        </Link>
        <div className="device-info">
          <h5 className="assigned-num">{props.assignee}</h5>
          <p className="assigned-text text-dark">Assigned Device</p>
        </div>
        <div className="user-dates">
          <p className="user-data-text text-dark">
            Date Added: <span> {props.date} </span>
          </p>

          {props.id &&
            (endDate !== "" ? (
              <p className="user-data-text text-dark">
                Subscription End:{" "}
                <span>
                  {new Date(endDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </span>
              </p>
            ) : (
              <p className="user-data-text text-dark">
                Subscription End: <span>---</span>
              </p>
            ))}

          {props.dealerId &&
            (dealerEndDate !== "" ? (
              <p className="user-data-text text-dark">
                Subscription End:{" "}
                <span>
                  {new Date(dealerEndDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </span>
              </p>
            ) : (
              <p className="user-data-text text-dark">
                Subscription End: <span>---</span>
              </p>
            ))}
        </div>

        <div className="user-contact">
          <p className="user-data-text text-dark">
            Phone: <span> {props.phone} </span>
          </p>
          <p className="user-data-text text-dark">
            Email: <span> {props.email} </span>
          </p>
        </div>
      </div>

      <div className="card-actions">
        <button
          type="button"
          onClick={props.onUpdate}
          className="btn-action"
          aria-label="Edit"
        >
          <EditIcon />
        </button>

        <button
          type="button"
          onClick={props.onClick}
          className="btn-action"
          aria-label="Delete"
        >
          <DeleteIcon />
        </button>
      </div>
    </div>
  );
};

export default DealerCard;
